/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { SaleID } from './sale-model';

export class GetSaleInput {
	startAt?: SaleID

	limit?: number
}